import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ChatState } from './chats.reducer';

export const selectChatState = createFeatureSelector<ChatState>('chats');

// Select all chat users
export const selectChatUsers = createSelector(
  selectChatState,
  (state: ChatState) => state.users
);

// Select current chat user
export const selectCurrentChatUser = createSelector(
  selectChatState,
  (state: ChatState) => state.currentUser
);

// Select all messages for current chat
export const selectMessages = createSelector(
  selectChatState,
  (state: ChatState) => state.messages
);

// Select loading state
export const selectChatLoading = createSelector(
  selectChatState,
  (state: ChatState) => state.loading
);

// Select error state
export const selectChatError = createSelector(
  selectChatState,
  (state: ChatState) => state.error
);

// Select messages between specific users (if needed)
export const selectMessagesBetweenUsers = (senderId: number, receiverId: number) =>
  createSelector(
    selectMessages,
    (messages) => messages.filter(msg =>
      (msg.senderId === senderId && msg.receiverId === receiverId) ||
      (msg.senderId === receiverId && msg.receiverId === senderId)
    )
  );
